// GENERATED FILE — do not edit, do not commit (see .gitignore).
// Written by frontend/scripts/generate-version.js on install and on every build.
export const buildInfo = {
  commit: 'cebc2d3',
  branch: 'preproduction',
  buildDate: '2026-11-03T10:52:22.486Z',
  dirty: true,
} as const;
